import { Customer } from '../types/customer'
import { Machine } from '../types/machine'
import { User } from '../types/user'
import {
  setIsFahrenheit,
  setIsPounds,
  setSelectedCuppingRoasts,
  setSelectedCustomer,
  setEnabledBetaFeatures,
  setLastSelectedMachine,
} from '../utils/localStorageUtils'

export const START_LOAD_MACHINES = 'loadMachines'
export const MACHINES_LOAD_SUCCESS = 'machinesLoadSuccess'
export const MACHINES_LOAD_ERROR = 'machinesLoadError'
export const CURRENT_MACHINE_LOAD_ERROR = 'currentMachineLoadError'

export const START_LOAD_USER = 'loadUser'
export const USER_LOAD_SUCCESS = 'userLoadSuccess'
export const USER_LOAD_ERROR = 'userLoadError'

export const SET_CURRENT_MACHINE = 'setCurrentMachine'
export const SET_CURRENT_CUSTOMER = 'setCurrentCustomer'

export const SET_CUPPING_ROASTS = 'setCuppingRoasts'

export type ActionType =
  | LoadMachines
  | MachinesLoadSuccess
  | MachinesLoadError
  | CurrentMachineLoadError
  | LoadUser
  | UserLoadSuccess
  | UserLoadError
  | SetCurrentMachine
  | SetCurrentCustomer
  | SetCuppingRoasts

export enum UserLoadErrorSubtype {
  NoUser,
  NoCustomer,
  Unknown,
}

export interface LoadMachines {
  type: typeof START_LOAD_MACHINES
}
export interface MachinesLoadSuccess {
  type: typeof MACHINES_LOAD_SUCCESS
  machines: Array<Machine>
}
export interface MachinesLoadError {
  type: typeof MACHINES_LOAD_ERROR
}
export interface CurrentMachineLoadError {
  type: typeof CURRENT_MACHINE_LOAD_ERROR
}

export interface LoadUser {
  type: typeof START_LOAD_USER
}
export interface UserLoadSuccess {
  type: typeof USER_LOAD_SUCCESS
  user: User
}
export interface UserLoadError {
  type: typeof USER_LOAD_ERROR
  error: UserLoadErrorSubtype
}
export interface SetCurrentMachine {
  type: typeof SET_CURRENT_MACHINE
  machine: Machine | null
}

export interface SetCurrentCustomer {
  type: typeof SET_CURRENT_CUSTOMER
  customer: Customer
}

export interface SetCuppingRoasts {
  type: typeof SET_CUPPING_ROASTS
  roastIds: Array<string>
}

//

export const loadMachines = (): LoadMachines => {
  return {
    type: START_LOAD_MACHINES,
  }
}

export const machinesLoaded = (machines: Array<Machine>): MachinesLoadSuccess => {
  return {
    type: MACHINES_LOAD_SUCCESS,
    machines,
  }
}

export const machinesLoadError = (): MachinesLoadError => {
  return {
    type: MACHINES_LOAD_ERROR,
  }
}

export const currentMachineLoadError = (): CurrentMachineLoadError => {
  return {
    type: CURRENT_MACHINE_LOAD_ERROR,
  }
}

export const loadUser = (): LoadUser => {
  return {
    type: START_LOAD_USER,
  }
}

export const userLoaded = (user: User): UserLoadSuccess => {
  // when user is set, update temperature settings in localStorage
  setIsFahrenheit(user.fahrenheit)
  setIsPounds(user.is_pounds)
  return {
    type: USER_LOAD_SUCCESS,
    user,
  }
}

export const userLoadError = (error: UserLoadErrorSubtype): UserLoadError => {
  return {
    type: USER_LOAD_ERROR,
    error: error,
  }
}

export const setCurrentMachine = (machine: Machine | null): SetCurrentMachine => {
  if (machine) {
    setLastSelectedMachine(machine.slug)
  }
  return {
    type: SET_CURRENT_MACHINE,
    machine,
  }
}

export const setCurrentCustomer = (customer: Customer, resetMachine: Boolean): SetCurrentCustomer => {
  setSelectedCustomer(customer.url)
  if (resetMachine) {
    setLastSelectedMachine('')
  }
  setEnabledBetaFeatures(customer.enabled_beta_features)
  return {
    type: SET_CURRENT_CUSTOMER,
    customer,
  }
}

export const setCuppingRoastIds = (roastIds: Array<string>): SetCuppingRoasts => {
  setSelectedCuppingRoasts(roastIds)
  return {
    type: SET_CUPPING_ROASTS,
    roastIds,
  }
}
